// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"dc820da0","455":"b865675b","507":"6ea80ae6","612":"0323b7f1","980":"0ee5823c"}[chunkId] + ".chunk.js";
};